module.exports = __webpack_public_path__ + "img/claim-icon-active.0dc4f30b.svg";